import { render } from "./PrintTitle.vue?vue&type=template&id=96db2908&scoped=true"
import script from "./PrintTitle.vue?vue&type=script&lang=js"
export * from "./PrintTitle.vue?vue&type=script&lang=js"

import "./PrintTitle.vue?vue&type=style&index=0&id=96db2908&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96db2908"]])

export default __exports__